import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import SEO from '../components/SEO';

/**
 * Fallback verify page — redirects to the server-side verify endpoint
 * which returns a branded HTML page directly.
 */
export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const redirected = useRef(false);

  useEffect(() => {
    if (redirected.current) return;
    redirected.current = true;

    const token = searchParams.get('token');
    if (token) {
      // Redirect to server endpoint that handles verification + returns HTML
      window.location.href = `/api/auth/verify-email?token=${token}`;
    }
  }, [searchParams]);

  return (
    <>
    <SEO
      title="Verify Your Email"
      description="Verify your email address to activate your Euchre Table account and claim your free Bucks."
      path="/verify"
      noindex={true}
    />
    <div style={{
      minHeight: '100vh', background: '#0d1117',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      color: '#c9d1d9', fontFamily: "'Georgia', serif"
    }}>
      <p>Redirecting to verification...</p>
    </div>
    </>
  );
}
